import { ts } from '_core';

export const prepareBarData = (resources: ts.StoreState['resources'], data: ts.types.widgets.TableData) => {
  const newNestedBarData: ts.types.widgets.TableData = [];

  data.forEach((item) => {
    const newItem: ts.types.widgets.TableData[number] = {};

    Object.keys(item).forEach((key) => {
      if (key === 'category') {
        newItem[key] = item[key];
      } else {
        const newKey = resources.time_series.find((ts) => ts.handle === key)?.name;
        if (newKey) {
          newItem[newKey] = item[key];
        }
      }
    });

    newNestedBarData.push(newItem);
  });

  return newNestedBarData;
};

export const prepareData = (resources: ts.StoreState['resources'], data: ts.types.widgets.TableData) => {
  const newData = data.map((item) => {
    const newItem = { date: item.date } as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      const newKey = resources.time_series.find((ts) => ts.handle === key)?.name;
      if (newKey) {
        newItem[newKey] = item[key];
      }
    });

    return newItem;
  });

  return newData;
};
